// The below error codes and error types should be in sync with the PHP error codes class o.w. it will break error handling from front-end

export const PLAID_ERROR_TYPES = {
  API_ERROR: 'API_ERROR',
  ITEM_ERROR: 'ITEM_ERROR',
  ITEM_NOT_FOUND: 'ITEM_NOT_FOUND',
  AUTH_ERROR: 'AUTH_ERROR',
  INVALID_INPUT: 'INVALID_INPUT',
  INVALID_REQUEST: 'INVALID_REQUEST',
  INSTITUTION_ERROR: 'INSTITUTION_ERROR',
  RATE_LIMIT_EXCEEDED: 'RATE_LIMIT_EXCEEDED',
}

export const PLAID_ERROR_CODES = {
  API_ERROR: {
    INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
    PLANNED_MAINTENANCE: 'PLANNED_MAINTENANCE',
  },
  ITEM_ERROR: {
    INSUFFICIENT_CREDENTIALS: 'INSUFFICIENT_CREDENTIALS',
    INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
    INVALID_MFA: 'INVALID_MFA',
    INVALID_SEND_METHOD: 'INVALID_SEND_METHOD',
    INVALID_UPDATED_USERNAME: 'INVALID_UPDATED_USERNAME',
    ITEM_LOCKED: 'ITEM_LOCKED',
    ITEM_LOGIN_REQUIRED: 'ITEM_LOGIN_REQUIRED',
    ITEM_NO_ERROR: 'ITEM_NO_ERROR',
    ITEM_NOT_SUPPORTED: 'ITEM_NOT_SUPPORTED',
    ITEM_ERROR: 'ITEM_ERROR',
    INCORRECT_DEPOSIT_AMOUNTS: 'INCORRECT_DEPOSIT_AMOUNTS',
    TOO_MANY_VERIFICATION_ATTEMPTS: 'TOO_MANY_VERIFICATION_ATTEMPTS',
    USER_SETUP_REQUIRED: 'USER_SETUP_REQUIRED',
    MFA_NOT_SUPPORTED: 'MFA_NOT_SUPPORTED',
    NO_ACCOUNTS: 'NO_ACCOUNTS',
    NO_AUTH_ACCOUNTS: 'NO_AUTH_ACCOUNTS',
    NO_INVESTMENT_ACCOUNTS: 'NO_INVESTMENT_ACCOUNTS',
    NO_LIABILITY_ACCOUNTS: 'NO_LIABILITY_ACCOUNTS',
    PRODUCT_NOT_READY: 'PRODUCT_NOT_READY',
    PRODUCTS_NOT_SUPPORTED: 'PRODUCTS_NOT_SUPPORTED',
    ITEM_CONCURRENTLY_DELETED: 'ITEM_CONCURRENTLY_DELETED',
    PRODUCT_NOT_ENABLED: 'PRODUCT_NOT_ENABLED',
    ITEM_PRODUCT_NOT_READY: 'ITEM_PRODUCT_NOT_READY',
    ACCESS_NOT_GRANTED: 'ACCESS_NOT_GRANTED',
    USER_PERMISSION_REVOKED: 'USER_PERMISSION_REVOKED',
  },
  AUTH_ERROR: {
    PRODUCTS_NOT_SUPPORTED: 'PRODUCT_NOT_READY',
    VERIFICATION_EXPIRED: 'VERIFICATION_EXPIRED',
  },
  INVALID_INPUT: {
    INVALID_API_KEYS: 'INVALID_API_KEYS',
    UNAUTHORIZED_ENVIRONMENT: 'UNAUTHORIZED_ENVIRONMENT',
    INVALID_ACCESS_TOKEN: 'INVALID_ACCESS_TOKEN',
    INVALID_PUBLIC_TOKEN: 'INVALID_PUBLIC_TOKEN',
    INVALID_PRODUCT: 'INVALID_PRODUCT',
    INVALID_ACCOUNT_ID: 'INVALID_ACCOUNT_ID',
    INVALID_INSTITUTION: 'INVALID_INSTITUTION',
    INVALID_CREDENTIAL_FIELDS: 'INVALID_CREDENTIAL_FIELDS',
  },
  INVALID_REQUEST: {
    MISSING_FIELDS: 'MISSING_FIELDS',
    INVALID_HEADERS: 'INVALID_HEADERS',
    UNKNOWN_FIELDS: 'UNKNOWN_FIELDS',
    INVALID_FIELD: 'INVALID_FIELD',
    INVALID_BODY: 'INVALID_BODY',
    NOT_FOUND: 'NOT_FOUND',
    SANDBOX_ONLY: 'SANDBOX_ONLY',
  },
  INSTITUTION_ERROR: {
    VERIFICATION_EXPIRED: 'INSTITUTION_DOWN',
    INSTITUTION_NOT_RESPONDING: 'INSTITUTION_NOT_RESPONDING',
    INSTITUTION_NOT_AVAILABLE: 'INSTITUTION_NOT_AVAILABLE',
    INSTITUTION_NO_LONGER_SUPPORTED: 'INSTITUTION_NO_LONGER_SUPPORTED',
  },
  RATE_LIMIT_EXCEEDED: {
    ACCOUNTS_LIMIT: 'ACCOUNTS_LIMIT',
    ADDITION_LIMIT: 'ADDITION_LIMIT',
    AUTH_LIMIT: 'AUTH_LIMIT',
    IDENTITY_LIMIT: 'IDENTITY_LIMIT',
    INCOME_LIMIT: 'INCOME_LIMIT',
    ITEM_GET_LIMIT: 'ITEM_GET_LIMIT',
    RATE_LIMIT: 'RATE_LIMIT',
    TRANSACTIONS_LIMIT: 'TRANSACTIONS_LIMIT',
  },
}

export const PLAID_ITEM_FATAL_ERROR_TYPES = [
  PLAID_ERROR_TYPES.ITEM_ERROR,
  PLAID_ERROR_TYPES.ITEM_NOT_FOUND,
  PLAID_ERROR_TYPES.API_ERROR,
  PLAID_ERROR_TYPES.AUTH_ERROR,
  PLAID_ERROR_TYPES.INSTITUTION_ERROR,
  PLAID_ERROR_TYPES.INVALID_REQUEST,
  PLAID_ERROR_TYPES.INVALID_INPUT,
  PLAID_ERROR_TYPES.RATE_LIMIT_EXCEEDED,
]

export const PLAID_ITEM_FATAL_ERROR_CODES = [
  PLAID_ERROR_CODES.ITEM_ERROR.INSUFFICIENT_CREDENTIALS,
  PLAID_ERROR_CODES.ITEM_ERROR.INVALID_CREDENTIALS,
  PLAID_ERROR_CODES.ITEM_ERROR.INVALID_MFA,
  PLAID_ERROR_CODES.ITEM_ERROR.INVALID_SEND_METHOD,
  PLAID_ERROR_CODES.ITEM_ERROR.INVALID_UPDATED_USERNAME,
  PLAID_ERROR_CODES.ITEM_ERROR.ITEM_LOCKED,
  PLAID_ERROR_CODES.ITEM_ERROR.ITEM_LOGIN_REQUIRED,
  PLAID_ERROR_CODES.ITEM_ERROR.ITEM_NO_ERROR,
  PLAID_ERROR_CODES.ITEM_ERROR.ITEM_NOT_SUPPORTED,
  PLAID_ERROR_CODES.ITEM_ERROR.ITEM_ERROR,
  PLAID_ERROR_CODES.ITEM_ERROR.INCORRECT_DEPOSIT_AMOUNTS,
  PLAID_ERROR_CODES.ITEM_ERROR.TOO_MANY_VERIFICATION_ATTEMPTS,
  PLAID_ERROR_CODES.ITEM_ERROR.USER_SETUP_REQUIRED,
  PLAID_ERROR_CODES.ITEM_ERROR.MFA_NOT_SUPPORTED,
  PLAID_ERROR_CODES.ITEM_ERROR.NO_ACCOUNTS,
  PLAID_ERROR_CODES.ITEM_ERROR.NO_AUTH_ACCOUNTS,
  PLAID_ERROR_CODES.ITEM_ERROR.NO_INVESTMENT_ACCOUNTS,
  PLAID_ERROR_CODES.ITEM_ERROR.NO_LIABILITY_ACCOUNTS,
  PLAID_ERROR_CODES.ITEM_ERROR.PRODUCT_NOT_READY,
  PLAID_ERROR_CODES.ITEM_ERROR.PRODUCTS_NOT_SUPPORTED,
  PLAID_ERROR_CODES.ITEM_ERROR.ITEM_CONCURRENTLY_DELETED,
  PLAID_ERROR_CODES.ITEM_ERROR.PRODUCT_NOT_ENABLED,
  PLAID_ERROR_CODES.ITEM_ERROR.ITEM_PRODUCT_NOT_READY,
  PLAID_ERROR_CODES.ITEM_ERROR.ACCESS_NOT_GRANTED,
  PLAID_ERROR_CODES.AUTH_ERROR.VERIFICATION_EXPIRED,
  PLAID_ERROR_CODES.INSTITUTION_ERROR.INSTITUTION_NO_LONGER_SUPPORTED,
  PLAID_ERROR_CODES.INVALID_REQUEST.INVALID_FIELD,
  PLAID_ERROR_CODES.INVALID_INPUT.INVALID_ACCOUNT_ID,
  PLAID_ERROR_CODES.ITEM_ERROR.USER_PERMISSION_REVOKED,
]

export const PLAID_RELINK_BANNER_DAYS = 1
